import React, { useEffect } from 'react';

import { useAxios } from '../../../AxiosHandler';

import { useTranslate } from 'react-polyglot';
import { useNavigate, useParams } from 'react-router-dom';

import styles from './Userinvite.module.scss';
import { Form } from 'react-bootstrap';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Userinvite(props: UserinviteProps) {
    const t = useTranslate();
    const params = useParams();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const navigate = useNavigate();

    const [email, setEmail] = React.useState<string>("");
    const [password, setPassword] = React.useState<string>("");
    const [confirmPassword, setConfirmPassword] = React.useState<string>("");

    // Regular expression for password validation
    // At least 8 characters, at least one uppercase letter, one lowercase letter, and one number
    // Norsk: Minst 8 tegn, minst en stor bokstav, en liten bokstav og et tall
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;

    // Email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function createUser() {
        // Check if the passwords match
        if (password !== confirmPassword) {
            alert(t('userinvite.form.passwordmismatch'));
            return;
        }

        // Create user with the invite token
        axios.single({
            method: 'post',
            url: "/api/users/createuserfrominvite/",
            data:{
                email: email,
                password: password,
                inviteid: params.inviteid
            },
            responseType: 'json'
        }).then((res: any) => {
            if (res.status !== 200) {
                toast.error(t('userinvite.form.error'), {
                    position: "top-center",
                    autoClose: 5000,
                });
                return;
            }
            // Go to login page
            navigate('/login');
            toast.success(t('userinvite.form.success'), {
                position: "top-center",
                autoClose: 5000,
            });
        }).catch((err: any) => {
            console.log(err);
            toast.error(t('userinvite.form.error'), {
                position: "top-center",
                autoClose: 5000,
            });
        });
    }
    
    return (
        <div className={styles.userinvite}>
            <h1>{t('userinvite.title')}</h1>
            <p>{t('userinvite.description')}</p>

            <div className={styles.inviteform}>
                <Form
                    className={styles.form}
                >
                    <Form.Group
                        controlId="formBasicEmail"
                        className="mb-3"
                    >
                        <Form.Label>{t('userinvite.form.email')}</Form.Label>
                        <Form.Control 
                            type="email" 
                            placeholder={t('userinvite.form.emailplaceholder')} 
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            aria-invalid={!emailRegex.test(email)}
                            isValid={emailRegex.test(email)}
                        />
                    </Form.Group>

                    <Form.Group controlId="formBasicPassword" className="mb-3">
                        <Form.Label>{t('userinvite.form.password')}</Form.Label>
                        <Form.Control 
                            type="password" 
                            placeholder={t('userinvite.form.passwordplaceholder')} 
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            aria-invalid={!passwordRegex.test(password)}
                            isValid={passwordRegex.test(password)}
                            isInvalid={password !== confirmPassword && password !== "" && confirmPassword !== ""}
                        />
                    </Form.Group>

                    <Form.Group controlId="formBasicPasswordConfirm" className="mb-4">
                        <Form.Label>{t('userinvite.form.confirmpassword')}</Form.Label>
                        <Form.Control 
                            type="password" 
                            placeholder={t('userinvite.form.confirmpasswordplaceholder')} 
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            aria-invalid={password !== confirmPassword && password !== "" && confirmPassword !== ""}
                            isValid={password === confirmPassword && password !== "" && confirmPassword !== ""}
                            isInvalid={password !== confirmPassword && password !== "" && confirmPassword !== ""}
                        />
                    </Form.Group>
                </Form>

                { email !== "" && !emailRegex.test(email) ?
                    <p className={styles.error}>
                        {t('userinvite.form.emailerror')}
                    </p>
                : null }

                { email == "" && password == "" && confirmPassword == "" ?
                    <p className={styles.error}>
                        {t('userinvite.form.fillouterror')}
                    </p>
                : null }

                { !passwordRegex.test(password) && password !== "" ?
                    <p className={styles.error}>
                        {t('userinvite.form.passworderror')}
                    </p>
                : null }
                
                { passwordRegex.test(password) && password !== confirmPassword && password !== "" && confirmPassword !== "" ?
                    <p className={styles.error}>
                        {t('userinvite.form.passwordmismatch')}
                    </p>
                : null }

                <button
                    className="btn btn-primary"
                    disabled={
                        email === "" ||
                        password === "" ||
                        confirmPassword === "" ||
                        password !== confirmPassword ||
                        !passwordRegex.test(password) ||
                        !emailRegex.test(email)
                    }
                    onClick={(e) => {
                        e.preventDefault();
                        createUser();
                    }}
                >
                    {t('userinvite.form.submit')}
                </button>
            </div>
        </div>
    );
}

class UserinviteProps {

}

export default Userinvite;